import { render, staticRenderFns } from "./SendConfirmCodeForm.vue?vue&type=template&id=0352afb5&scoped=true&"
import script from "./SendConfirmCodeForm.vue?vue&type=script&lang=js&"
export * from "./SendConfirmCodeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0352afb5",
  null
  
)

export default component.exports